'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackToTop = function () {
  function BackToTop(el) {
    (0, _classCallCheck3.default)(this, BackToTop);

    this.el = el;

    this.isTicking = false;
    this.lastKnownY = 0;
    this.appearAt = window.innerHeight;

    this.setupListeners();
  }

  (0, _createClass3.default)(BackToTop, [{
    key: 'setupListeners',
    value: function setupListeners() {
      window.addEventListener('scroll', this.onScroll.bind(this));
      this.el.addEventListener('click', function () {
        return (0, _utils.scrollToY)(0);
      });
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = window.scrollY;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.updateEl.bind(this));

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      // Do fun stuffs here
      this.el.classList.toggle('pg-BackToTop-active', this.lastKnownY >= this.appearAt);
    }
  }]);
  return BackToTop;
}();

exports.default = BackToTop;